// import theme from '@ifca-root/react-component/src/assets/theme';
import {
	Avatar,
	IconButton,
	ListItemSecondaryAction,
	Menu,
	MenuItem,
} from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import TakeawayIcon from 'assets/icons/takeaway_footer_color.svg';
import GrabFoodIcon from 'assets/icons/grabfood.png';
import FoodPandaIcon from 'assets/icons/foodpanda.png';
import AppContext from 'containers/App/Store/AppContext';
import { PosPermission, useGetUserLogoQuery } from 'generated/graphql';
import { useBroadcastChannel } from 'helpers/hooks/useBroadcastChannel';
import { usePermissionChecker } from 'helpers/hooks/usePermissionChecker';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import {
	AccountJournalsIcon,
	BillListingIcon,
	BusinessInsightsIcon,
	GeneralSettingsIcon,
	HomeIcon,
	KitchenAppIcon,
	LogoutIcon,
	OutletSettingsIcon,
	SideMenuHomeIcon,
	UtilityIcon,
	WebsiteAppNewIcon,
} from '../../assets';
import UserProfile from '../../assets/icons/user-profile.svg';
import io from 'socket.io-client';
import { SystemMsgs } from 'helpers/SystemMsg';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import { menuxSocketUrl } from 'POSClient';
import { SocketContext } from 'containers/Socket/SocketContext';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { getServerURL } from 'containers/OutletModule/Home/TableSubmenu/BillSettlement/BixolonJS/bxlcommon';

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		drawer: {
			[theme.breakpoints.up('sm')]: {
				// width: '240px',
				width: drawerWidth,
				flexShrink: 0,
			},
		},
		drawerPaper: {
			// width: '240px',
			width: drawerWidth,
			[theme.breakpoints.up('sm')]: {
				top: 64,
				height: 'calc(100% - 64px)',
			},
			zIndex: 100,
		},
		content: {
			flexGrow: 1,
			padding: theme.spacing(3),
		},
		activeListItem: {
			borderLeft: '4px solid red',
			boxShadow: '0 3px 2px -3px gray',
			backgroundColor: '#ff9800',
			'& $listItemText': {
				color: 'white',
				marginTop: 0,
				marginBottom: 0,
				fontWeight: 500,
			},
			'& $listItemIcon': {
				color: 'white',
				marginLeft: '-4px',
				minWidth: '36px',
			},
		},
		listItemText: {
			fontSize: '1rem',
			fontWeight: 400,
			color: 'black',
			marginTop: 0,
			marginBottom: 0,
		},
	}),
);

interface Props {
	windowConatiner?: () => Window;
	open?: boolean;
	variant?: any;
	onCloseDrawer?: any;
}

// export interface LayoutDrawerNavs {
// 	name: string;
// 	path: string;
// 	icon: string;
// 	iconActive: string;
// }

// export interface LayoutDrawerProps extends DrawerProps {
// 	/**
// 	 * Injected by the documentation to work in an iframe.
// 	 * You won't need it on your project.
// 	 */
// 	window?: () => Window;
// 	activeIndex?: number;
// 	onCloseDrawer?: any;
// }

export const LayoutDrawer = (props: Props) => {
	// const { navs = [], ...rest } = props;
	const { windowConatiner, open, onCloseDrawer, variant, ...rest } = props;
	const classes = useStyles();
	const outletID = localStorage.getItem('latestOutlet');
	const container =
		windowConatiner !== undefined
			? () => windowConatiner().document.body
			: undefined;
	let history = useHistory();
	const { globalState, dispatch }: any = useContext(AppContext as any);
	// const [user] = useAtom(userAtom); sorry george don't have time to learn this yet
	let location = useLocation();
	const userData: any = location?.state;
	const user = JSON.parse(localStorage.getItem('loggedInUser')) ?? userData;
	const outlet: any = JSON.parse(localStorage.getItem('Outlet'));
	const eInvoice = outlet?.company?.isEInvIntegrated || false;
	const { signOut } = useBroadcastChannel();

	const isIn = (route: string, module: string) => {
		return route.match(module);
	};

	const { handlePermHidden } = usePermissionChecker();

	const pathName: any = history?.location?.pathname;

	let isHome = false,
		isKitchenApp = false,
		isOutletApp = false,
		isCustomerApp = false;

	if (
		// isIn(pathName, '/') ||
		isIn(pathName, '/home') ||
		isIn(pathName, '/alternate')
	) {
		isHome = true;
	}
	if (isIn(pathName, 'kitchen/home')) {
		isKitchenApp = true;
		// isHome = false;
	}
	if (isIn(pathName, 'outlet-app')) {
		isOutletApp = true;
		// isHome = false;
	}
	if (isIn(pathName, 'patron-app')) {
		isCustomerApp = true;
		// isHome = false;
	}

	// console.log(open, 'open');

	const { data: pic } = useGetUserLogoQuery({
		variables: {
			refID: user?.ID,
		},
	});

	const [menuLoaded, setMenuLoaded] = useState(false);
	// Simulate loading time with useEffect hook
	useEffect(() => {
		// Simulate asynchronous data loading
		const loadData = async () => {
			// Your data loading logic here (if any)
			// For now, just simulate a 1-second delay
			await new Promise(resolve => setTimeout(resolve, 500));
			setMenuLoaded(true);
		};

		loadData();
	}, [open]);

	// const { setOpenSnackBar, setSnackBarMsg } = useContext(
	// 	SnackBarContext as any,
	// );

	// const [socket, setSocket] = useState(null);

	// useEffect(() => {
	// 	const newSocket = io('http://localhost:9000');

	// 	setSocket(newSocket);

	// 	// Cleanup function
	// 	return () => {
	// 	  newSocket.disconnect();
	// 	};
	//   }, []);

	//   console.log(socket, "socket")

	//   useEffect(() => {

	// 	if (socket) {

	// 	  socket.on('notification', (notification) => {
	// 		console.log("apa")
	// 		// HotelNotification({
	// 		//   variables: {
	// 		// 	NotificationType: 'All',
	// 		// 	HotelID: Hotel,
	// 		// 	UserID: LoggedInUser?.ID,
	// 		//   }
	// 		// })
	// 		console.log(notification,'notification')
	// 		// setOpenSnackBar(true);
	// 		// setSnackBarMsg(SystemMsgs.autoDayEndTime());
	// 	  });
	// 	}

	//   }, [socket])

	const { socket }: any = useContext(SocketContext);
	const [grabFoodOrderCount, setGrabFoodOrderCount] = useState(0);
	const [foodPandaOrderCount, setFoodPandaOrderCount] = useState(0);

	// Shared audio context that persists across renders
	const audioContextRef = useRef<AudioContext | null>(null);

	// Initialize audio context on mount and unlock it on user interaction
	useEffect(() => {
		const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
		if (!AudioContextClass) {
			console.warn('[GrabFood Drawer] Web Audio API not supported');
			return;
		}

		// Create audio context
		audioContextRef.current = new AudioContextClass();

		// Unlock audio context on first user interaction (required by browser autoplay policies)
		const unlockAudio = async () => {
			if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
				try {
					await audioContextRef.current.resume();
					console.log('[GrabFood Drawer] Audio context unlocked');
				} catch (error) {
					console.warn('[GrabFood Drawer] Failed to unlock audio context:', error);
				}
			}
		};

		// Try to unlock on various user interactions
		const events = ['click', 'touchstart', 'keydown'];
		events.forEach(event => {
			document.addEventListener(event, unlockAudio, { once: true, passive: true });
		});

		return () => {
			// Cleanup
			events.forEach(event => {
				document.removeEventListener(event, unlockAudio);
			});
			if (audioContextRef.current) {
				audioContextRef.current.close().catch(() => {});
			}
		};
	}, []);

	// Function to play notification sound
	const playNotificationSound = async () => {
		try {
			if (!audioContextRef.current) {
				const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
				if (!AudioContextClass) {
					console.warn('[GrabFood Drawer] Web Audio API not supported');
					return;
				}
				audioContextRef.current = new AudioContextClass();
			}

			const audioContext = audioContextRef.current;

			// Resume audio context if suspended (required by browser autoplay policies)
			if (audioContext.state === 'suspended') {
				try {
					await audioContext.resume();
					console.log('[GrabFood Drawer] Audio context resumed');
				} catch (error) {
					console.warn('[GrabFood Drawer] Failed to resume audio context:', error);
					return;
				}
			}

			// Create oscillator for a pleasant notification tone
			const oscillator = audioContext.createOscillator();
			const gainNode = audioContext.createGain();
			
			// Connect oscillator to gain node, then to destination
			oscillator.connect(gainNode);
			gainNode.connect(audioContext.destination);
			
			// Set a pleasant frequency (two-tone chime: starts at 800Hz, goes to 1000Hz)
			oscillator.frequency.setValueAtTime(800, audioContext.currentTime);
			oscillator.frequency.setValueAtTime(1000, audioContext.currentTime + 0.1);
			oscillator.type = 'sine'; // Use sine wave for a softer, more pleasant tone
			
			// Set volume envelope (fade in and out for a smooth sound) - louder volume
			gainNode.gain.setValueAtTime(0, audioContext.currentTime);
			gainNode.gain.linearRampToValueAtTime(0.7, audioContext.currentTime + 0.01);
			gainNode.gain.linearRampToValueAtTime(0.5, audioContext.currentTime + 0.15);
			gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + 0.3);
			
			// Play the sound
			oscillator.start(audioContext.currentTime);
			oscillator.stop(audioContext.currentTime + 0.3);

			console.log('[GrabFood Drawer] Notification sound played');
		} catch (error) {
			console.error('[GrabFood Drawer] Failed to play notification sound:', error);
		}
	};

	// Listen for new GrabFood orders via socket
	useEffect(() => {
		if (!socket) {
			console.warn('[GrabFood Drawer] Socket not available');
			return;
		}

		if (!outletID) {
			console.warn('[GrabFood Drawer] OutletID not available');
			return;
		}

		// Normalize outletID (remove quotes if present from localStorage)
		const normalizedOutletID = outletID.replace(/^["']|["']$/g, '');

		console.log('[GrabFood Drawer] Setting up socket listener for outlet:', normalizedOutletID);
		console.log('[GrabFood Drawer] Socket connected:', socket.connected);

		const handleNewGrabFoodOrder = (data: any) => {
			console.log('[GrabFood Drawer] ===== RECEIVED SOCKET EVENT =====');
			console.log('[GrabFood Drawer] Event data:', JSON.stringify(data, null, 2));
			console.log('[GrabFood Drawer] Current outletID:', normalizedOutletID);
			console.log('[GrabFood Drawer] Received outletID:', data.outletID);
			console.log('[GrabFood Drawer] Type check:', {
				currentType: typeof normalizedOutletID,
				receivedType: typeof data.outletID
			});
			
			// Normalize both IDs for comparison
			const receivedOutletID = String(data.outletID || '').trim();
			const currentOutletID = String(normalizedOutletID || '').trim();
			
			console.log('[GrabFood Drawer] Normalized comparison:', {
				received: receivedOutletID,
				current: currentOutletID,
				match: receivedOutletID === currentOutletID
			});
			
			// Only increment count if the order is for the current outlet
			if (receivedOutletID === currentOutletID) {
				// Check delivery platform type
				const platform = data.deliveryPlatform || 'GrabFood'; // Default to GrabFood for backward compatibility
				if (platform === 'GrabFood') {
					// Play notification sound when GrabFood order is received
					playNotificationSound();
					
					setGrabFoodOrderCount(prev => {
						const newCount = prev + 1;
						console.log('[GrabFood Drawer] ✓ GrabFood count updated from', prev, 'to', newCount);
						return newCount;
					});
				} else if (platform === 'FoodPanda') {
					setFoodPandaOrderCount(prev => {
						const newCount = prev + 1;
						console.log('[GrabFood Drawer] ✓ FoodPanda count updated from', prev, 'to', newCount);
						return newCount;
					});
				}
			} else {
				console.warn('[GrabFood Drawer] ✗ Outlet ID mismatch - ignoring event');
			}
		};

		// Also listen for connection events
		socket.on('connect', () => {
			console.log('[GrabFood Drawer] Socket connected');
		});

		socket.on('disconnect', () => {
			console.log('[GrabFood Drawer] Socket disconnected');
		});

		socket.on('grabfood:newOrder', handleNewGrabFoodOrder);
		console.log('[GrabFood Drawer] Socket listener registered for event: grabfood:newOrder');

		return () => {
			console.log('[GrabFood Drawer] Cleaning up socket listener');
			socket.off('grabfood:newOrder', handleNewGrabFoodOrder);
			socket.off('connect');
			socket.off('disconnect');
		};
	}, [socket, outletID]);

	// Reset count when user navigates to Takeaway page
	useEffect(() => {
		if (isIn(pathName, '/takeaway')) {
			setGrabFoodOrderCount(0);
			setFoodPandaOrderCount(0);
		}
	}, [pathName]);

	const navigations = isOutletApp
		? [
				{
					name: 'Home',
					path: `/menu/outlet-app/${outletID}/table/grid`,
					icon: SideMenuHomeIcon,
					iconActive: HomeIcon,
					permission: PosPermission.HomeTableLayoutView,
				},
				{
					name: 'Takeaway',
					path: `/menu/outlet-app/${outletID}/takeaway`,
					icon: TakeawayIcon,
					iconActive: TakeawayIcon,
					permission: PosPermission.TakeawayShow,
				},
				{
					name: 'Common Settings',
					path: `/menu/outlet-app/common-setting`,
					icon: GeneralSettingsIcon,
					iconActive: GeneralSettingsIcon,
					permission: PosPermission.GeneralSettingShow,
				},
				{
					name: 'General Settings',
					path: `/menu/outlet-app/general-setting`,
					icon: GeneralSettingsIcon,
					iconActive: GeneralSettingsIcon,
					permission: PosPermission.GeneralSettingShow,
				},
				{
					name: 'Outlet Settings',
					path: `/menu/outlet-app/outlet-setting`,
					icon: OutletSettingsIcon,
					iconActive: OutletSettingsIcon,
					permission: PosPermission.OutletSettingShow,
				},
				{
					name: 'Bill Listing',
					path: `/menu/outlet-app/${outletID}/bill-listing`,
					icon: BillListingIcon,
					iconActive: BillListingIcon,
					permission: PosPermission.BillListingShow,
				},
				// {
				// 	name: 'Reservations',
				// 	path: `/menu/outlet-app/${outletID}/reservation`,
				// 	icon: ReservationTableIcon,
				// 	iconActive: ReservationTableIcon,
				// 	permission: PosPermission.ReservationShow,
				// },
				// {
				// 	name: 'Online Orders',
				// 	path: `/menu/outlet-app/online-order`,
				// 	icon: OnlineOrdersIcon,
				// 	iconActive: OnlineOrdersIcon,
				// },
				{
					name: 'Utility',
					path: `/menu/outlet-app/utility`,
					icon: UtilityIcon,
					iconActive: UtilityIcon,
					permission: PosPermission.UtilityShow,
				},
				{
					name: 'Business Analytics',
					path: `/menu/outlet-app/business-insight/business-analytic`,
					icon: BusinessInsightsIcon,
					iconActive: BusinessInsightsIcon,
					permission: PosPermission.BizAnalyticsShow,
				},
				{
					name: `Digital Reporting`,
					path: `/menu/outlet-app/${outletID}/digital-reporting`,
					icon: BusinessInsightsIcon,
					iconActive: BusinessInsightsIcon,
					//label1: `Booking, Transaction, Manager Report`,
					permission: PosPermission.DigitalReportingShow,
				},
				{
					path: `/menu/outlet-app/${outletID}/digital-bill`,
					name: `Digital Document`,
					icon: BusinessInsightsIcon,
					iconActive: BusinessInsightsIcon,
					//label1: `Digital Bill`,
					permission: PosPermission.DigitalDocumentShow,
				},
				{
					name: 'Account Journals',
					path: `/menu/outlet-app/account-journals`,
					icon: AccountJournalsIcon,
					iconActive: AccountJournalsIcon,
					permission: PosPermission.AccountJournalsShow,
				},
				// Conditionally include the eInvoice item if eInvoice is true
				...(eInvoice === true
					? [
							{
								name: 'Consolidated e-Invoice',
								path: `/menu/outlet-app/${outletID}/consolidate-e-inovoice`,
								icon: AccountJournalsIcon,
								iconActive: AccountJournalsIcon,
								permission: PosPermission.ConsolidatedEInvoiceShow,
							},
					  ]
					: []),
				{
					name: 'Kitchen',
					path: `/kitchen/login`,
					icon: KitchenAppIcon,
					iconActive: KitchenAppIcon,
					permission: PosPermission.KitchenIcon,
				},
				// {
				// 	name: 'Printer Server',
				// 	path: `/printer-server/login`,
				// 	icon: WebsiteAppNewIcon,
				// 	iconActive: WebsiteAppNewIcon,
				// 	permission: PosPermission.PrinterServerIcon,
				// },
				{
					name: 'Logout',
					path: `/logout`,
					icon: LogoutIcon,
					iconActive: LogoutIcon,
					permission: undefined,
				},
		  ]
		: isKitchenApp
		? [
				{
					name: 'Logout',
					path: `/logout`,
					icon: LogoutIcon,
					iconActive: LogoutIcon,
					permission: undefined,
				},
		  ]
		: [
				{
					name: 'Logout',
					path: `/logout`,
					icon: LogoutIcon,
					iconActive: LogoutIcon,
					permission: undefined,
				},
		  ];

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const handleProfileClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleRedirectProfile = () => {
		if (!!onCloseDrawer) {
			onCloseDrawer();
		}
		setAnchorEl(null);
		history.push({
			pathname: '/profile',
		});

		localStorage.setItem('prevPath', location.pathname);
	};

	const pathname = location ? location.pathname : '';

	const drawer = (
		<div className="route-container">
			<List disablePadding>
				{navigations?.map((v, i) => {
					if (
						handlePermHidden({
							outletID: outletID,
							permEnum: v.permission,
						})
					)
						return (
							<ListItem
								autoFocus={false}
								button
								key={i}
								dense
								activeClassName={'active'}
								divider
								component={
									v?.name === 'Kitchen' || v?.name === 'Printer Server'
										? null
										: NavLink
								}
								selected={false}
								to={
									v?.name === 'Kitchen' || v?.name === 'Printer Server'
										? pathname
										: v?.path
								}
								onClick={() => {
									if (!!onCloseDrawer) {
										onCloseDrawer();
									}
									if (v?.name === 'Takeaway') {
										// Reset count when user clicks on Takeaway
										setGrabFoodOrderCount(0);
										setFoodPandaOrderCount(0);
									}
									if (v?.name === 'Sign Out') {
										signOut(user?.ID);
										sessionStorage.clear();
										sessionStorage.removeItem('key');
									}
									if (v?.name === 'Printer Server') {
										window.open(`/printer-server/login`);
									}
									if (v?.name === 'Kitchen') {
										window.open(`/kitchen/login`);
									}
								}}
							>
								<ListItemIcon>
									<img className="icon-svg" src={v?.icon} alt="drawer-icon" />
									{/* <img
									className="icon-svg"
									src={v?.iconActive}
									alt="drawer-icon"
								/> */}
								</ListItemIcon>
								<ListItemText primary={v?.name} />
								{v?.name === 'Takeaway' && (grabFoodOrderCount > 0 || foodPandaOrderCount > 0) && (
									<ListItemSecondaryAction>
										<div style={{ 
											display: 'flex', 
											alignItems: 'center', 
											gap: '6px',
											marginRight: '8px'
										}}>
											{grabFoodOrderCount > 0 && (
												<div style={{ 
													display: 'flex', 
													alignItems: 'center', 
													position: 'relative'
												}}>
													<img 
														src={GrabFoodIcon} 
														alt="GrabFood" 
														style={{ width: '20px', height: '20px' }}
													/>
													<div style={{
														position: 'absolute',
														top: '-6px',
														right: '-6px',
														backgroundColor: '#f44336',
														color: 'white',
														borderRadius: '50%',
														width: '16px',
														height: '16px',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														fontSize: '9px',
														fontWeight: 'bold',
														border: '1.5px solid white',
														minWidth: '16px',
														padding: '0 2px',
														boxSizing: 'border-box'
													}}>
														{grabFoodOrderCount > 99 ? '99+' : grabFoodOrderCount}
													</div>
												</div>
											)}
											{foodPandaOrderCount > 0 && (
												<div style={{ 
													display: 'flex', 
													alignItems: 'center', 
													position: 'relative'
												}}>
													<img 
														src={FoodPandaIcon} 
														alt="FoodPanda" 
														style={{ width: '20px', height: '20px' }}
													/>
													<div style={{
														position: 'absolute',
														top: '-6px',
														right: '-6px',
														backgroundColor: '#d32f2f',
														color: 'white',
														borderRadius: '50%',
														width: '16px',
														height: '16px',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														fontSize: '9px',
														fontWeight: 'bold',
														border: '1.5px solid white',
														minWidth: '16px',
														padding: '0 2px',
														boxSizing: 'border-box'
													}}>
														{foodPandaOrderCount > 99 ? '99+' : foodPandaOrderCount}
													</div>
												</div>
											)}
										</div>
									</ListItemSecondaryAction>
								)}
							</ListItem>
						);
				})}
			</List>
		</div>
	);

	// User Profile Wrapper
	const userProfile = (
		<div className="profile-container">
			<div className="profile-avatar">
				{/* <Avatar alt="avatar" className="avatar" /> */}
				{pic?.logoView?.fileURL ? (
					<img src={pic?.logoView?.fileURL} alt="" className="avatar" />
				) : (
					<Avatar alt="avatar" className="avatar" />
				)}
			</div>
			<List className="profile-list" disablePadding>
				<ListItem>
					<ListItemText
						primary={
							<span
								className=""
								style={{
									fontWeight: 700,
									fontSize: '14px',
									fontFamily:
										['Poppins', 'sans-serif'].join(',') + ' !important',
								}}
							>
								{user?.name}
							</span>
						}
						secondary={
							<span
								className=""
								style={{
									fontSize: '10px',
									fontFamily:
										['Poppins', 'sans-serif'].join(',') + ' !important',
								}}
							>
								{user?.email}
							</span>
						}
					/>
					<ListItemSecondaryAction>
						<IconButton
							edge="end"
							aria-label="simple-menu"
							onClick={handleProfileClick}
						>
							<ExpandMore />
						</IconButton>
					</ListItemSecondaryAction>
				</ListItem>
			</List>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				className="drawer-submenu"
			>
				<MenuItem className="drawer-dropdown" onClick={handleRedirectProfile}>
					<img className="icon-dropdown-svg" src={UserProfile} alt="" /> Profile
				</MenuItem>
				<MenuItem
					className="drawer-dropdown"
					onClick={() => {
						signOut(user?.ID);
						sessionStorage.clear();
						sessionStorage.removeItem('key');
						history.push('/logout');
					}}
				>
					<img className="icon-dropdown-svg" src={LogoutIcon} alt="" /> Logout
				</MenuItem>
			</Menu>
		</div>
	);

	const EpsonEposPrinter = () => {
		const [printerStatus, setPrinterStatus] = useState<
			'idle' | 'sending' | 'success' | 'error' | 'timeout'
		>('idle');

		const [printerMessage, setPrinterMessage] = useState<string>('');
		const [status, setStatus] = useState('ready');

		const printTextTesting = async () => {
			// Use same API base as rest of app so proxy always hits menu-node (backend → printer)
			const backendOrigin =
				typeof menuxSocketUrl === 'string' && menuxSocketUrl
					? new URL(menuxSocketUrl).origin
					: window.location.hostname === 'localhost'
					? 'http://localhost:9000'
					: window.location.origin;
			const proxyUrl = `${backendOrigin}/api/epson-printer-proxy/cgi-bin/epos/service.cgi`;

			setPrinterStatus('sending');
			setPrinterMessage('Sending print job...');

			const timeoutId = window.setTimeout(() => {
				setPrinterStatus('timeout');
				setPrinterMessage(
					'No response from printer (paper empty / cover open / offline)',
				);
			}, 8000);

			try {
				// Build print XML (ePOS fragment); backend proxy will wrap in SOAP and forward to printer
				const epsonPrinter = new (window as any).epson.ePOSPrint();
				epsonPrinter.addTextLang('en');
				epsonPrinter.addTextFont(epsonPrinter.FONT_A);
				epsonPrinter.addTextAlign(epsonPrinter.ALIGN_CENTER);
				epsonPrinter.addTextSize(2, 2);
				epsonPrinter.addText('RECEIPT TEST2\n');
				epsonPrinter.addTextSize(1, 1);
				epsonPrinter.addFeedLine(1);
				epsonPrinter.addText('----------------\n');
				epsonPrinter.addText('MenuX Print Test\n');
				epsonPrinter.addText(
					`${new Date().toLocaleDateString('en-GB', {
						day: 'numeric',
						month: 'short',
						year: 'numeric',
					})} ${new Date().toLocaleTimeString('en-GB', {
						hour: '2-digit',
						minute: '2-digit',
					})}\n`,
				);
				epsonPrinter.addText('If you can read this,\n');
				epsonPrinter.addText('the printer is working.\n');
				epsonPrinter.addText('----------------\n');
				epsonPrinter.addFeedLine(2);
				epsonPrinter.addCut();
				const xmlBody = (epsonPrinter as any).message || '';

				const resp = await fetch(proxyUrl, {
					method: 'POST',
					headers: { 'Content-Type': 'text/xml; charset=utf-8' },
					body: xmlBody,
					credentials: 'include',
				});
				window.clearTimeout(timeoutId);
				const responseText = await resp.text();
				const success = resp.ok && /success="true"/i.test(responseText);
				if (success) {
					setPrinterStatus('success');
					setPrinterMessage('Printed – check the receipt paper.');
				} else {
					setPrinterStatus('error');
					const codeMatch = responseText.match(/code="([^"]*)"/);
					setPrinterMessage(codeMatch?.[1] || `Print failed (${resp.status})`);
				}
			} catch (err) {
				window.clearTimeout(timeoutId);
				setPrinterStatus('error');
				setPrinterMessage(
					err?.message || 'Network error – is the server running?',
				);
			}
		};

		return (
			<div style={{ padding: 12, borderBottom: '1px solid #ddd' }}>
				<div>Printer: {status}</div>

				<button onClick={printTextTesting}>Print Test</button>
				<div style={{ marginTop: 8 }}>
					<strong>Status:</strong> {printerStatus === 'sending' && '🟡 Sending'}
					{printerStatus === 'success' && '🟢 Printed'}
					{printerStatus === 'error' && '🔴 Error'}
					{printerStatus === 'timeout' && '⚠️ No response'}
				</div>

				{printerMessage && (
					<div style={{ fontSize: 12, color: '#666' }}>{printerMessage}</div>
				)}
			</div>
		);
	};

	return (
		// <Loading/>
		<nav aria-label="main menu" hidden={!open}>
			{menuLoaded && (
				<Drawer
					{...rest}
					container={container}
					variant={variant}
					anchor={'left'}
					open={open}
					onClose={onCloseDrawer}
					className="drawer"
					classes={{
						paper: classes.drawerPaper,
					}}
					ModalProps={{
						keepMounted: true, // Better open performance on mobile.
					}}
				>
					<EpsonEposPrinter />
					{userProfile}
					{drawer}
				</Drawer>
			)}
		</nav>
	);
};
